const envUrl = process.env.REACT_APP_BACKEND_URL;

const resolveBackendUrl = () => {
  if (typeof window === "undefined" || !envUrl) return envUrl;
  try {
    const envHost = new URL(envUrl).host;
    const pageHost = window.location.host;
    if (envHost !== pageHost && envHost.replace(/^www\./, "") === pageHost.replace(/^www\./, "")) {
      return window.location.origin;
    }
  } catch (e) {
    return envUrl;
  }
  return envUrl;
};

export const BACKEND_URL = resolveBackendUrl();
